import { createSlice } from '@reduxjs/toolkit';

export const CargoSlice = createSlice({
  name: 'cargo',
  initialState: {
    cargos_list: [],
    cargo: {},
    cargos_select: [],
  },
  reducers: {
    setCargosRedux: (state, { payload }) => {
      state.cargos_list = payload;
    },
    storeCargoRedux: (state, { payload }) => {
      state.cargo = payload;
    },
    setCargosSelectRedux: (state, { payload }) => {
      state.cargos_select = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setCargosRedux, storeCargoRedux, setCargosSelectRedux } = CargoSlice.actions;
